import { c as _c } from "react/compiler-runtime";
import { ExternalLink } from "../shared/external-link";
import { ClickableCode } from "./clickable-code";
export function Example(t0) {
  const $ = _c(16);
  const {
    onToClick,
    remark,
    to,
    url
  } = t0;
  let t1;
  if ($[0] !== onToClick || $[1] !== to) {
    t1 = function handleCodeClick() {
      onToClick?.(to);
    };
    $[0] = onToClick;
    $[1] = to;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCodeClick = t1;
  let t2;
  if ($[3] !== handleCodeClick || $[4] !== to) {
    t2 = <ClickableCode onClick={handleCodeClick}>njt {to}</ClickableCode>;
    $[3] = handleCodeClick;
    $[4] = to;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== remark) {
    t3 = <span className="whitespace-nowrap">({remark})</span>;
    $[6] = remark;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <span>{t2}{" "}{t3}</span>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== url) {
    t5 = <span className="block truncate">🐸 → <ExternalLink href={url} /></span>;
    $[11] = url;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <p>{t4}{t5}</p>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}